import { m } from "framer-motion";
import { cn } from "~/lib/utils";

interface ProgressRingProps {
  className?: string;
  /** Size in pixels. */
  size?: number;
  strokeWidth?: number;
}

/**
 * Indeterminate circular spinner: a fixed 25% arc rotating over a faint
 * track. Strokes use currentColor — set a text color class on the caller.
 * Continuous spinner rotation is exempt from the fluidSprings tiers.
 */
export function ProgressRing({
  className,
  size = 32,
  strokeWidth = 2.5,
}: ProgressRingProps) {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;
  const arcLength = circumference * 0.25;

  return (
    <div
      className={cn("relative", className)}
      data-testid="progress-ring"
      style={{ width: size, height: size }}
    >
      <svg
        className="-rotate-90 transform"
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        width={size}
      >
        <circle
          className="stroke-current opacity-20"
          cx={center}
          cy={center}
          fill="none"
          r={radius}
          strokeWidth={strokeWidth}
        />
        <m.g
          animate={{ rotate: 360 }}
          style={{ transformOrigin: `${center}px ${center}px` }}
          transition={{ duration: 1, ease: "linear", repeat: Infinity }}
        >
          <circle
            className="stroke-current"
            cx={center}
            cy={center}
            fill="none"
            r={radius}
            strokeDasharray={`${arcLength} ${circumference - arcLength}`}
            strokeLinecap="round"
            strokeWidth={strokeWidth}
          />
        </m.g>
      </svg>
    </div>
  );
}
